import { clearSession, getAuthenticationUrl } from './auth0-pcke';
import { createWorkspaceContext } from './create-workspace-context';
import { logEvent } from './log-event';
import { Inject } from '@nestjs/common';
import { Args, Mutation, Resolver } from '@nestjs/graphql';
import fetch from 'node-fetch';

@Resolver()
export class MutationResolver {
  constructor(
    @Inject('telemetry') private readonly telemetry: any,
    @Inject('readSettings') private readonly readSettings: any,
    @Inject('commands') private readonly commands: any
  ) {}

  @Mutation()
  async createAttachment(@Args('workspace') workspace: string) {
    try {
      const attachment = workspace
        ? await createWorkspaceContext(
            this.readSettings,
            this.commands.history,
            workspace
          )
        : null;

      return { attachment };
    } catch (e) {
      console.log(e);
      throw new Error(`Error when creating context. Message: "${e.message}"`);
    }
  }

  @Mutation()
  async getAuthenticationUrl() {
    logEvent(this.telemetry, 'authenticate');
    const authenticationUrl = await getAuthenticationUrl();
    return { authenticationUrl };
  }

  @Mutation()
  async unauthenticate() {
    try {
      logEvent(this.telemetry, 'unauthenticate');

      clearSession();
      return { response: 'Success' };
    } catch (e) {
      console.log(e);
      throw new Error(
        `Error when attempting to unauthenticate. Message: "${e.message}"`
      );
    }
  }

  @Mutation()
  async trackLogin(
    @Args('userId') userId: string = '91ced190-44dd-4d8d-95c7-a79c5e07095d'
  ) {
    console.log('Attempting to track login for', userId);

    const category = 'Angular Console Extension Login';
    const gaId = 'UA-88380372-9';

    fetch('https://www.google-analytics.com/collect', {
      method: 'post',
      body: `v=1&t=event&tid=${gaId}&cid=${userId}&ec=${encodeURIComponent(
        category
      )}&ea=login&el=angular_console_extension`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
    return { result: true };
  }
}
